import React from "react";
import styles from "./HeroSection.module.css";

export default function HeroSection({ logo }) {
  return (
    <div className={styles.logoContainer}>
      <img src={logo} loading="lazy" alt="logo" className={styles.logo} />
    </div>
  );
}
